import { createPinia } from 'pinia'
import { cloneDeep } from 'lodash-es'

const pinia = createPinia()

pinia.use(({ store }) => {
  const initialState = cloneDeep(store.$state)
  // eslint-disable-next-line no-param-reassign
  store.$reset = () => {
    store.$patch($state => {
      Object.assign($state, cloneDeep(initialState))
    })
  }
})

export default pinia
